import modeEnums from "../../../../enums/modeEnums";
import FireboardUtils from "../../../../util/fireboard-util";

export default class CommonUtil {
  static getCheckConfig = (
    check,
    currentMode,
    storeInfo,
    setSelectedCheck,
    onHandleSms,
    updateOrderStatus,
    viewGuestLocationOnMap,
    onOrderDelivered
  ) => {
    let config = { data: [], buttons: [] };
    if (currentMode === modeEnums.TABLE_DELIVERY) {
      config = CommonUtil.getTableDeliveryCheckConfig(check, setSelectedCheck, onHandleSms, updateOrderStatus);
    } else if (currentMode === modeEnums.GPS_LOCATION) {
      config = CommonUtil.getGPSLocationCheckConfig(check, storeInfo, viewGuestLocationOnMap, onOrderDelivered, onHandleSms, setSelectedCheck);
    }

    return config;
  };

  static getTableDeliveryCheckConfig = (check, setSelectedCheck, onHandleSms, updateOrderStatus) => {
    let name = '';
    const checkName = check.checkName;
    const tabName = check.tabName;
    if (checkName) {
      name = checkName;
    }
    if (tabName && tabName !== name) {
      name = `${name}\n${tabName}`;
    }

    let actionButtons = [
      {
        key: 'notify',
        name: 'Notify',
        onClick: () => {
          onHandleSms(check);
          setSelectedCheck(check);
        }
      },
      {
        key: 'complete',
        name: 'Complete',
        onClick: () => {
          updateOrderStatus(check, 'done');
        }
      },
    ];

    const dataArray = [
      { value: `Name: ${name}` },
      { value: `Deliver To: ${check.deliverTo}` },
    ];

    const checkConfig = {
      data: dataArray,
      buttons: actionButtons,
    };
    return checkConfig;
  };

  static getGPSLocationCheckConfig(check, storeInfo, viewGuestLocationOnMap, onOrderDelivered, onHandleSms, setSelectedCheck) {
    let actionButtons = [
      {
        key: 'notify',
        name: 'Notify',
        onClick: () => {
          onHandleSms && onHandleSms(check);
          setSelectedCheck && setSelectedCheck(check);
        }
      },
      {
        key: 'delivered',
        name: 'Delivered',
        onClick: () => {
          onOrderDelivered && onOrderDelivered(check);
        }
      },
    ];

    const { enableGpsLocation, latitude, longitude } = storeInfo || {};
    if (FireboardUtils.isViewOnMapOptionVisible(enableGpsLocation, latitude, longitude, check.orders)) {
      const viewOnMapBtn = {
        key: 'viewOnMap',
        name: 'View on Map',
        onClick: () => {
          viewGuestLocationOnMap && viewGuestLocationOnMap();
        }
      };
      actionButtons = [...actionButtons, viewOnMapBtn];
    }

    const dataArray = [
      { value: `#${check.number}` },
      { value: check.deliverTo },
      { value: check.ellapsedTime },
    ];

    const checkConfig = {
      data: dataArray,
      buttons: actionButtons,
    };
    return checkConfig;
  }
}
